import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { isUrl } from "@devowl-wp/react-utils";
import { extendCommonGroupsStylesheet, extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts/stylesheet.js";
import { useBannerOrBlocker } from "../../../hooks/useBannerOrBlocker.js";
const CookieProperty = (param)=>{
    let { label, value, children, printValueAs, monospace } = param;
    const stylesheet = useStylesheet();
    const { Link, CookieProperty } = stylesheet.extend(...extendCommonStylesheet).extend(...extendCommonGroupsStylesheet);
    const banner = useBannerOrBlocker();
    const { i18n: { yes, no } } = banner;
    const isValueUrl = typeof value === "string" && value.startsWith("http") && isUrl(value);
    let useValue = isValueUrl ? /*#__PURE__*/ _jsx(Link, {
        href: value,
        target: "_blank",
        rel: "noopener noreferrer",
        children: value
    }) : typeof value === "string" ? printValueAs === "phone" ? /*#__PURE__*/ _jsx(Link, {
        target: "_blank",
        href: `tel:${value.replace(/\s+/g, "")}`,
        children: value
    }) : printValueAs === "mail" ? /*#__PURE__*/ _jsx(Link, {
        target: "_blank",
        href: `mailto:${value}`,
        children: value
    }) : /*#__PURE__*/ _jsx("span", {
        dangerouslySetInnerHTML: {
            __html: value
        }
    }) : value;
    if (printValueAs === "boolean") {
        useValue = useValue ? yes : no;
    }
    return value || value === false || printValueAs === "empty" ? /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(CookieProperty, {
                children: [
                    label && /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            label,
                            ":\xa0"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        role: "presentation",
                        style: {
                            fontFamily: monospace ? "monospace" : undefined
                        },
                        children: useValue
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CookieProperty, {
                children: !!children && /*#__PURE__*/ _jsx("div", {
                    children: children
                })
            })
        ]
    }) : null;
};
export { CookieProperty };
